<div class="flex gap-1 items-center">
  <span class="text-proffeo-muted text-sm">
    {{ 'task-details-modal-changed-priority' | translate }}: {{ priorityTranslationKey() | translate }}
  </span>
</div>
